import { useEffect, useRef } from "react";
import { redactUrl } from "./scrub";
import { setTelemetryRoute, trackEvent } from "./telemetry";

export interface RouteTelemetryOptions {
  /** Maps a pathname to a route template; defaults to `redactUrl` (IDs replaced with `:id`). */
  template?: (pathname: string) => string;
  /** Non-personal scope identifiers taken from the path, e.g. `{ businessId }`. */
  scope?: (pathname: string) => Record<string, string | undefined>;
}

/** Reports each route view as a template and keeps the current route on every signal. */
export function useRouteTelemetry(pathname: string, action: string, options: RouteTelemetryOptions = {}) {
  const previous = useRef<{ pathname: string; route: string }>(undefined);
  const { template = redactUrl, scope } = options;
  useEffect(() => {
    if (previous.current?.pathname === pathname) return;
    const route = template(pathname) || "/";
    setTelemetryRoute(route, scope?.(pathname));
    trackEvent("navigation.route_viewed", { route, action: action.toLowerCase(), previousRoute: previous.current?.route });
    previous.current = { pathname, route };
  }, [pathname, action, template, scope]);
}
